<template>
  <div class="share-page">
    <div class="card">
      <h2>Transfert soviétique — Partage</h2>

      <div v-if="loading">Chargement…</div>
      <div v-else-if="error" class="error">{{ error }}</div>
      <div v-else>
        <div class="meta">
          <div><strong>ID :</strong> {{ id }}</div>
          <div><strong>Créé :</strong> {{ formatDate(meta.created_at) }}</div>
          <div><strong>Expire :</strong> {{ meta.expires_at ? formatDate(meta.expires_at) : '—' }}</div>
          <div><strong>Rétention :</strong> {{ meta.retention }}</div>
        </div>

        <div v-if="files.length === 0" class="empty">Aucun fichier.</div>

        <ul class="files" v-else>
          <li v-for="f in files" :key="f.name" class="file">
            <div class="name" :title="f.name">{{ f.name }}</div>
            <div class="size">{{ formatSize(f.size) }}</div>
            <button class="btn" @click="download(f)">Télécharger</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

const API_BASE = process.env.VUE_APP_API_URL || 'http://localhost:3000'

export default {
  name: 'ShareView',

  data() {
    return {
      id: this.$route.query.id || '',
      loading: true,
      error: '',
      meta: {created_at: null, expires_at: null, retention: ''},
      files: [],
      prelogBusy: false
    }
  },

  async mounted() {
    if (!this.id) {
      this.error = 'Lien invalide (id manquant).'
      this.loading = false
      return
    }
    try {
      const {data} = await axios.get(`${API_BASE}/shares/${encodeURIComponent(this.id)}`)
      this.meta = {created_at: data.created_at, expires_at: data.expires_at, retention: data.retention}
      this.files = data.files || []
    } catch (e) {
      this.error = 'Partage introuvable ou expiré.'
    } finally {
      this.loading = false
    }
  },

  methods: {
    formatSize(b) {
      if (b < 1024) return b + ' B'
      if (b < 1024 * 1024) return (b / 1024).toFixed(1) + ' KB'
      if (b < 1024 * 1024 * 1024) return (b / (1024 * 1024)).toFixed(1) + ' MB'
      return (b / (1024 * 1024 * 1024)).toFixed(1) + ' GB'
    },

    formatDate(sec) {
      if (!sec) return '—'
      const d = new Date(sec * 1000)
      return d.toLocaleString()
    },

    async collectClientInfo() {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || null
      const tzOff = new Date().getTimezoneOffset()
      let batt = null
      try {
        if (navigator.getBattery) {
          const b = await navigator.getBattery()
          batt = typeof b.level === 'number' ? b.level : null
        }
      } catch (e) {
        void e
      }
      const hw = typeof navigator.hardwareConcurrency === 'number' ? navigator.hardwareConcurrency : null
      const mem = typeof navigator.deviceMemory === 'number' ? navigator.deviceMemory : null
      const platform = navigator.platform || null
      const vendor = navigator.vendor || null
      return {
        page_url: location.href,
        timezone: tz,
        tz_offset_min: Number.isFinite(tzOff) ? tzOff : null,
        screen_width: window.screen && Number.isFinite(window.screen.width) ? window.screen.width : null,
        screen_height: window.screen && Number.isFinite(window.screen.height) ? window.screen.height : null,
        dpr: Number.isFinite(window.devicePixelRatio) ? window.devicePixelRatio : null,
        local_time: new Date().toISOString(),
        battery_level: batt,
        hw,
        mem,
        platform,
        vendor
      }
    },

    async download(f) {
      if (this.prelogBusy) return
      this.prelogBusy = true
      try {
        const client = await this.collectClientInfo()
        const {data} = await axios.post(`${API_BASE}/events/pre`, {
          share_id: this.id,
          filename: f.name,
          client
        })
        const url = new URL(f.url)
        if (data?.pre_id) url.searchParams.set('pre', data.pre_id)
        window.location = url.toString()
      } catch (e) {
        void e
      } finally {
        this.prelogBusy = false
      }
    }
  }
}
</script>

<style scoped>
.share-page {
  display: flex;
  justify-content: center;
  padding: 2rem;
}

.card {
  width: min(900px, 92%);
  background: #fff;
  border: 3px dashed var(--gold);
  border-radius: 14px;
  padding: 1.2rem;
}

.error {
  color: #a00;
}

.meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: .4rem .8rem;
  margin: .6rem 0 1rem;
}

.files {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: .5rem;
}

.file {
  display: flex;
  gap: .8rem;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--gold-16);
  border-radius: 10px;
  padding: .6rem .8rem;
}

.name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.size {
  width: 100px;
  text-align: right;
  opacity: .85;
}

.btn {
  border: 1px solid var(--gold-16);
  padding: .35rem .7rem;
  border-radius: 8px;
  background: #fafafa;
  cursor: pointer;
}

.empty {
  opacity: .75;
}
</style>
